import { Navigate, useLocation } from "react-router-dom";
import { languagesMenu } from "../Components/Public/CountriesLayout/CountriesLayout";
import adminRoutes from "../Routes/router/admin_routes";

import defaultRoutes from "../Routes/router/default_routes"

export const SUPPORTED_LANGS = languagesMenu.map(l => l.code);
export const DEFAULT_LANG = 'cs'; // TODO: change to en
export const DEFAUL_CURRENCY_LANG = 'en';

const routes_redirects = {
    "cz": "cs",
    "sk": "cs", // TODO: change after SK introduce
};

const DEFAULT_ROUTER = [];
const routes_mapping = {
    "cs": [],
}

export const isLocalhost = () => {
    const { hostname } = window.location;
    const isLocalhost = hostname.includes("localhost") || hostname.includes("192.168.0.100");

    return Boolean(isLocalhost);
}

const hasSubdomain = () => {
    const { hostname } = window.location;
    const parts = hostname.split(".");
    return isLocalhost() ? parts.length > 1 : parts.length > 2;
}

export const getSubdomain = () => {
    const { hostname } = window.location;
    const parts = hostname.split(".");
    return hasSubdomain() ? parts[0] : null;
}

export const isAdmin = () => {
    return getSubdomain() === "admin";
}

const getLocalizedRoutes = (subdomain) => {
    if (!subdomain) {
        return DEFAULT_ROUTER;
    }
    const router = routes_mapping[subdomain];
    if (router) {
        return router;
    }
    const redirect = routes_redirects[subdomain];
    if (redirect) {
        return routes_mapping[redirect];
    }
    return DEFAULT_ROUTER;
}

export const getRoutes = () => {
    const subdomain = getSubdomain();
    if (subdomain === "admin") {
        return adminRoutes;
    }

    const routes = getLocalizedRoutes(subdomain);
    return [...routes, ...defaultRoutes];
}

// Used for redirect to right subdomain
export function getPreferredLanguage() {
    const storageLang = hasStorageLang();
    if (storageLang && SUPPORTED_LANGS.includes(storageLang)) {
        return storageLang;
    }

    const langs = navigator.languages || [navigator.language || DEFAULT_LANG];

    for (const l of langs) {

        const code = l.slice(0, 2).toLowerCase();
        if (routes_mapping[code]) return code;

        const redirected = routes_redirects[code];
        if (redirected && routes_mapping[redirected]) return redirected;
    }

    return DEFAULT_LANG;
}

const STORAGE_LANG_KEY = "Language";

function hasStorageLang() {
    return localStorage?.getItem(STORAGE_LANG_KEY) || false;
}

export function setStorageLang(lang) {
    localStorage?.setItem(STORAGE_LANG_KEY, lang);
}

export function LanguageRedirect() {
    const { pathname, search, hash } = useLocation();
    const lng = getPreferredLanguage();

    // guard against a loop if this ever renders under an already-prefixed path
    if (pathname === `/${lng}` || pathname.startsWith(`/${lng}/`)) {
        return <Navigate to={{ pathname, search, hash }} replace />;
    }

    const suffix = pathname === "/" ? "" : pathname;
    return <Navigate to={{ pathname: `/${lng}${suffix}`, search, hash }} replace />;
}
